<!--
 * @Descripttion: 公共头部侧边栏入口文件
 * @version: 0.1
 * @Author: luoxi
 * @Date: 2020年3月16日16:47:50
 * @LastEditors: luoxi
 * @LastEditTime: 
 -->
<template>
  <div class="header-side">
    <Header />
    <div class="container">
      <Side />
      <div class="content">
        <router-view></router-view>
      </div>
    </div>
    <!-- <div class="slides"></div>
    <div class="kbs"></div> -->
  </div>
</template>

<script>
  import Header from './header'
  import Side from './side'
  export default {
      inject: ["reload"],
    components: {
      Header,
      Side,
    },
    data() {
      return {
        
      }
    },
 
    created() {

    },
    mounted() {
     
    },
    methods: {
    }
  }
</script>

<style scoped="" lang="scss">
.header-side {
  width: 100vw;
  height: 100vh;
  display: flex;
  flex-direction: column;
  .container {
    display: flex;
    flex-wrap: wrap;
    background-color: #f1eef4;
    height: calc(100% - 84px);
    .content {
      flex: 1;
      padding: 19px;
      width: calc(100% - 38px);
      height: calc(100% - 38px);
      overflow: hidden;
    }
  }
}
.slides {
  z-index: 1007;
  height: 100%;
  position: absolute;
  top: 0;
  left: -1px;
  // box-shadow: 0px 0px 6px rgba(43, 43, 43, 0.24);
  width: 60px;
}
.kbs {
  width: 59px;
  height: 10%;
  background: #1a74c6;
  position: absolute;
  z-index: 1001;
  top: 0;
  left: 0;
}
</style>
